import { z } from "zod"
import { LocaleCodeSchema } from "../shared/LocaleSchema.js"
import { TimestampSchema } from "../shared/Timestamp.js"
import { URISchema } from "../shared/URI.js"
import { UUIDv4Schema } from "../shared/UUIDv4.js"

/**
 * @description
 *	The schema of {@link FaceLivenessDetectionQueryParameters} type.
 */
export const FaceLivenessDetectionQueryParametersSchema = z.object({
	biometryId: UUIDv4Schema,
	context: z.string().trim().base64().optional(),
	dsa: UUIDv4Schema,
	expirationTimestamp: TimestampSchema,
	integrationId: UUIDv4Schema,
	locale: LocaleCodeSchema,
	redirectUri: URISchema,
	sessionId: UUIDv4Schema,
	signature: z.string().trim().min(64).max(512),
	stageVersion: z.coerce.number().int().gte(0)
})

/**
 * @description
 *	The signed URI query parameters of an FLD (Face Liveness Detection)
 *	process.
 */
export type FaceLivenessDetectionQueryParameters = z.infer<typeof FaceLivenessDetectionQueryParametersSchema>
